import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { secureStorage } from '../data-access/services/localstorage.service';
import { SweetAlertService } from '../../shared/data-access/services/swal-alert.service';
import { enPantallaDeAcademy } from './token.interceptor';

/**
 * Interceptor that handles 401 Unauthorized responses globally.
 * When the backend returns a 401 (token expired or invalid),
 * it clears all stored credentials and redirects the user to login.
 */
export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const router = inject(Router);
  const srvSwal = inject(SweetAlertService);

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !request.headers.has('X-Skip-Auth-Redirect')) {
        // En las pantallas de cursos (academy / registro) el 401 es del token del alumno: se cierra solo
        // esa sesión y se vuelve al aula, en vez de borrar todo y mandar al /login del staff. Solo si había
        // sesión de alumno, para que un 401 sin token no recargue la página en bucle.
        if (enPantallaDeAcademy()) {
          if (secureStorage.getSessionItem('token_cursos')) {
            secureStorage.removeSessionItem('token_cursos');
            secureStorage.removeItem('participante_cursos');
            srvSwal.fire({
              icon: 'info',
              title: 'Tu sesión expiró',
              text: 'Vuelve a iniciar sesión para continuar.',
              allowOutsideClick: false
            }).then(() => globalThis.location.assign('/academy'));
          }
          return throwError(() => error);
        }

        secureStorage.clearLocalStorage();
        sessionStorage.clear();

        router.navigate(['/login']);
      }

      return throwError(() => error);
    })
  );
};
